import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { PluginManagerService } from '../../../../service/plugin-manager.service';

@Component({
  selector: 'fdm-workflow-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)', opacity: 0, height:0 }),
        animate('0.2s 20ms ease-in-out', style({transform: 'translateY(0%)', opacity:1, height:'100%' }))
      ]),
      transition(':leave', [
        animate('0.2s 20ms ease-in-out', style({transform: 'translateY(-100%)', opacity:0, height:0 }))
      ])
    ])
  ]
})
export class PanelComponent implements OnInit {

  @Input()
  context:any = null;

  @Input()
  parent:any = null;

  @Input()
  idx:any = 0;

  constructor( public pluginManager: PluginManagerService ) { }

  ngOnInit() {
  }

  counter:number = 0;

  hasMenuItems() {
    // let state = this.context.state.state;
    if ( this.context.props['menu'] ) {
      return true;
    }
    return false;
  }

  hasItems ( idx:string = null ) {

    let state = this.context.state.state;
    
    if ( this.context.props['panels'] && this.context.props['panels'][state] && this.context.props['panels'][state][idx] ) {
      if ( this.context.props['panels'][state][idx]['length'] && this.context.props['panels'][state][idx].length > 0 ) {
        return true;
      }
    }
    return false;
  }

  isVisible( idx:string = null ) {

    this.counter++;
    // let state = this.context.state.state;

    if ( this.context && this.context.visual && this.context.config  ) {
      let mode = this.context.visual.state ? 'show' : 'hide';
      let showhide = this.context.config[mode];

      if ( this.counter < 10 ) {
        console.log ( '!', mode, this.context.config, this.context.config[mode] );
      }
      // if ( s && s[idx] ) {
        return showhide[idx];
      // }
      
    }
    return false;
  }

  isHidden( idx:string = null ) {
    let mode = ! this.context.visual.state ? 'show' : 'hide';
    return this.context.config[mode][idx];
  }

}
